<template>
  <ExternalQueryList
      headline="Opportunities"
      endpoint="/api/v2/opportunities"
      :endpoint-filters="{project_id: project.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => true"
      :can-destroy="() => false"
      @show="opportunity => $router.push('/companies/' +opportunity.attributes.company_id+'/opportunities/'+opportunity.id)"
  >
    <template v-slot:default="{ row: opportunity }">
      <td>
        <div style="display: flex; justify-content: space-between">
          <div>
            <router-link :to="'/companies/' +opportunity.attributes.company_id+'/opportunities/'+opportunity.id">
              {{ opportunity.attributes.company_name }}
            </router-link>
          </div>

          <div style="white-space:nowrap;">
            <i
                v-if="opportunity.attributes.company_has_active_partnership"
                class="fa fa-book-reader"
                v-tooltip="'Active partnership'"
            />

            <i v-else class="fa fa-book-reader" style="opacity: 0"/>
          </div>
        </div>
      </td>

      <td class="table__ellipsis">
        <Avatar :color="opportunity.attributes.user_color">
          {{ opportunity.attributes.user_initials }}
        </Avatar>
      </td>

      <td class="table__ellipsis">
        {{ opportunity.attributes.value | price }}
      </td>

      <td class="table__ellipsis">
        {{ opportunity.attributes.conversion_expected_at | date }}
      </td>

      <td>
        <span v-if="opportunity.attributes.status === 'converted'" class="label label-success">Converted</span>

        <span v-if="opportunity.attributes.status === 'open'" class="label label-warning">Open</span>

        <span v-if="opportunity.attributes.status === 'missed'" class="label label-danger">Missed</span>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import Avatar from "../../../Avatar.vue";

export default {
  components: {Avatar, ExternalQueryList},

  props: {
    project: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 4, text: 'Company'},
        {width: 4, text: 'User'},
        {width: 4, text: 'Value'},
        {width: 4, text: 'Expected At'},
        {width: 4, text: 'Status'},
      ]
    },
  }
}
</script>
